<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke
              v-on:osvezitevIzbranIdStranka="GetStranka"
              :selectorPermissions="selectorPermissions"
              :disabled="loadingPaketov"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div>
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine">
          <div>
            <p class="open-sans-30pt">
              T-2 paketi
            </p>
          </div>
          <div v-if="seznamNosilnihPrikljuckov.length !== 0">
            <div v-if="seznamNosilnihPrikljuckov.length > 1" style="padding-top: 20px">
              <p>
                Izberite priključek
                <IzbirnikPrikljuckaSelect
                  style-class="izbirnik-prikljuckov"
                  @novIzbranPrikljucek="izbranPrikljucek = $event"
                  :izbranPrikljucek="izbranPrikljucek"
                  :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
                />
              </p>
            </div>
            <div>
              <div style="padding-top: 15px" v-loading="loadingPaketov"
                   :class="loadingPaketov === true ? 'margin-top' : ''">
                <div id="checkbox-container-splosni_pogoji" style="display: none">
                  <input type="checkbox" class="cb-strinjanje-s-pogoji"
                         onchange="let vmesnik = document.getElementById('ch-strinanje-vmesnik2');
                                if (this.checked){vmesnik.value = '1';} else {vmesnik.value = '0';}
                                vmesnik.dispatchEvent(new Event('input')); "/>
                </div>
                <input type="hidden" id="ch-strinanje-vmesnik2" v-model="strinjanjeSPogojiPosrednik"/>
<!--                <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab">-->
<!--                  <el-tab-pane v-for="(skupina, key) in seznamZavihkov" :key="key"-->
<!--                               :label="skupina.naziv_skupine"-->
<!--                               :name="skupina.ref"-->
<!--                               ref="skupina.ref">-->
<!--                    <div v-if="activetab === skupina.ref">-->
<!--                      <T2Paket-->
<!--                        :infoIzbranegaPrikljucka="infoIzbranegaPrikljucka"-->
<!--                        :seznamPaketov="pogrupiranSeznamStoritev[skupina.vrstni_red_skupine]"-->
<!--                        :infoPripisObPaketu="infoPripisObPaketu"-->
<!--                        :izbranaHitrostPaket="izbranaHitrostPaket"-->
<!--                        :izbranaUgodnostPaket="izbranaUgodnostPaket"-->
<!--                        :seznamIzbranaUgodnostPaket="seznamIzbranaUgodnostPaket"-->
<!--                        :tabKey="tabKey"-->
<!--                        v-on:PrikaziPotrditvenoOknoZaNarociloStoritve="PrikaziPotrditvenoOknoZaNarociloStoritve"/>-->
<!--                    </div>-->
<!--                  </el-tab-pane>-->
<!--                </el-tabs>-->
                <el-tabs type="border-card" @tab-click="HandleTabClick" :value="activetab">
                  <el-tab-pane label="Vaš paket" ref="t1" name="t1">
                      <T2Paket
                        v-if="vklopljeniPaketi != null"
                        :infoIzbranegaPrikljucka="infoIzbranegaPrikljucka"
                        :seznamPaketov="vklopljeniPaketi"
                        :infoPripisObPaketu="infoPripisObPaketu"
                        :izbranaHitrostPaket="izbranaHitrostPaket"
                        :izbranaUgodnostPaket="izbranaUgodnostPaket"
                        :seznamIzbranaUgodnostPaket="seznamIzbranaUgodnostPaket"
                        :tabKey="tabKey"
                        @orderConfirmed="GetSeznamPaketov()"
                        v-on:PrikaziPotrditvenoOknoZaNarociloStoritve="PrikaziPotrditvenoOknoZaNarociloStoritve"
                        :naroceneStoritve="naroceneStoritve"
                      />
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
          <div v-if="seznamNosilnihPrikljuckov.length === 0 && !pridobivanjePodatkov">
            <div class="obvestilo-prazen-seznam">
              <p>
                Nimate priključka, ki bi omogočil naročilo.
              </p>
            </div>
          </div>
          <div v-if="seznamNosilnihPrikljuckov.length === 0 && !pridobivanjePodatkov">
            <div class="postavitev-info">
              <div class="info-okvir">
                <div class="postavitev-info-icone">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div class="postavitev-info-tekst">
                  <p class="modra-barva-info" v-if="kontaktniPodatki !== null">
                    Za naročilo prosim pokličite naš klicni center, ki je dosegljiv na
                    številki
                    <b>
                      {{ kontaktniPodatki.T2_SUPPORT_TEL_ST }}</b>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PrikazPogodbe
      :podatkiPogodbe="podatkiPogodbe"
      :izbranPrikljucek="izbranPrikljucek"
      :splosniPogojiPodjetja="splosniPogojiPodjetja"
      v-on:resetVrednostiDialoga="zapriDialog"
      :prikazi-dialog="prikaziDialog"
      v-on:potrjenaIzvajaSplosnihPogojev="NarociNovTrzniPaket"/>
  </div>
</template>
<script>
import T2Paket from './NarociTrzniPaketi/T2Paket.vue'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import {StoritevVrstaEnum} from '../../../../assets/js/Enum/StoritevVrstaEnum.js'
import {StoritevEnum} from '../../../../assets/js/Enum/StoritevEnum.js'
import {SeznamVrednosti} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti.js'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import {StoritveOpisFormat} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StoritveOpisFormat'
import Vue from 'vue'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {KontaktniPodatkiEnum} from '../../../../assets/js/Enum/KontaktniPodatkiEnum'

import {
  Select, Option, Form, Button, MessageBox, Checkbox, Collapse, CollapseItem, Col, Tabs,
  TabPane
} from 'element-ui'
import PrikazPogodbe from './PrikazPogodbe'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'

export default {
  name: 'NarociTrzniPaket',
  mixins: [StoritevEnum, PridobivanjeVklopljenoNaroceno, StringConverter, SeznamVrednosti, StoritveOpisFormat],
  data () {
    return {
      clientAgent: null,
      izbranPrikljucek: '',
      seznamMoznihStoritev: [],
      loadingPaketov: false,
      seznamIzvzeteVezave: [],
      vsebinaPogodbe: '',
      seznamZavihkov: [],
      pogrupiranSeznamStoritev: [],
      seznamStoritev: [],
      activetab: 't1',
      kontaktniPodatki: null,
      idIzbranaUgodnost: '',
      izbranaHitrostPaket: {},
      izbranaUgodnostPaket: {},
      seznamIzbranaUgodnostPaket: [],
      vklopljenNeaktualniPaket: false,
      infoPripisObPaketu: false,
      strinjanjeSPogojiPosrednik: '-1',
      tabKey: 0,
      aneksKey: 0,
      podatkiPogodbe: [],
      prikaziDialog: false,
      splosniPogojiPodjetja: '',
      seznamNosilnihPrikljuckov: [],
      seznamPrikljuckov: [],
      selectorPermissions: ['STRANKE_S_PRIKLJUCKI_S_TP'],
      pridobivanjePodatkov: true,
      infoIzbranegaPrikljucka: null,
      seznamPrikljuckovGrupirano: [],
      naroceneStoritve: null,
      vklopljeneStoritve: null,
      vklopljeniPaketi: null
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    PrikazPogodbe,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    'T2Paket': T2Paket,
    [Button.name]: Button,
    [Form.name]: Form,
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [Col.name]: Col,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  watch: {
    strinjanjeSPogojiPosrednik: function () {
      this.ObravnavajStrinjanjeSPogojiPosrednik()
    },
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetSeznamPaketov()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.seznamIzvzeteVezave = this.GetIzvzeteVezave()
    this.splosniPogojiPodjetja = povezave.BASE_URL_SPLOSNI_POGOJI_PODJETJA
    this.kontaktniPodatki = KontaktniPodatkiEnum
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.loadingPaketov === false && this.pogrupiranSeznamStoritev.length > 0) {
        let vmesnik = this
        setTimeout(function () {
          vmesnik.SetVisinaPrikazanihPaketov()
        }, 200)
      }
    })
    window.addEventListener('resize', this.SetVisinaPrikazanihPaketov)
  },
  methods: {
    updateVklopljeniPaketi () {
      let out = []
      if (Array.isArray(this.pogrupiranSeznamStoritev)) {
        if (this.pogrupiranSeznamStoritev.length > 0) {
          this.pogrupiranSeznamStoritev.forEach(skupina => {
            if (Array.isArray(skupina)) {
              skupina.forEach(paket => {
                if (paket.vklopljeno === 1) {
                  out = [paket]
                }
              })
            }
          })
        }
      }
      this.vklopljeniPaketi = out
    },
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStranka = podatkiStranke
        this.GetPrikljuckiDovoljenja(podatkiStranke)
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI_S_TP']
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamNosilnihPrikljuckov = []
      this.seznamPrikljuckov = []
      this.infoIzbranegaPrikljucka = null
      this.seznamPrikljuckov = podatki.permission.additionalData
      for (let i = 0; i < this.seznamPrikljuckov.length; i++) {
        if (this.seznamPrikljuckov[i].id_stranka === this.izbranaStranka) {
          Vue.set(
            this.seznamPrikljuckov[i],
            'podatekZaIzpisPrikljucek',
            this.seznamPrikljuckov[i].nazivPrikljuckaIzbirnik
          )
          this.seznamNosilnihPrikljuckov.push(this.seznamPrikljuckov[i])
          this.izbranPrikljucek = this.seznamNosilnihPrikljuckov[0].id_prikljucek
          this.infoIzbranegaPrikljucka = this.seznamNosilnihPrikljuckov[0]
        }
      }
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        this.seznamNosilnihPrikljuckov
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamNosilnihPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.pridobivanjePodatkov = false
    },
    zapriDialog () {
      this.prikaziDialog = false
    },
    HandleTabClick (tab) {
      this.activetab = tab.name
      this.infoPripisObPaketu = false
      if (this.vklopljenNeaktualniPaket && this.activetab === 't1') {
        this.infoPripisObPaketu = true
      }
    },
    PridobiNaroceneVklopljenStoritvePrikljucka () {
      let param = {}
      param.vmesnik = this
      param.prenesenIzbranId = this.izbranPrikljucek
      let seznamIskanihStoritev = [
        StoritevVrstaEnum.TRZNI_PAKET,
        StoritevVrstaEnum.NAROCNISKA_VEZAVA]
      param.idVrsta = [].concat(seznamIskanihStoritev, this.GetVrsteStoritveInternet())
      param.idStatusNaroceno = 0
      param.idStatusVklopljeno = 1
      this.GetVklopljeneStoritve(param)
    },
    PrikaziPotrditvenoOknoZaNarociloStoritve (paket, idHitrost, idUgodnost) {
      let idSviNovPaketString = paket.idStoritevVrstaIzbira.toString()
      let vklopljenPaket = null
      let narocenPaket = null
      for (let i = 0; i < this.pogrupiranSeznamStoritev.length; i++) {
        if (typeof this.pogrupiranSeznamStoritev[i] === 'undefined') {
          continue
        }
        for (let j = 0; j < this.pogrupiranSeznamStoritev[i].length; j++) {
          let idSviTpStr = this.pogrupiranSeznamStoritev[i][j].idStoritevVrstaIzbira.toString()
          let paketNarocen = this.pogrupiranSeznamStoritev[i][j].naroceno === 1
          let paketVklopljen = this.pogrupiranSeznamStoritev[i][j].vklopljeno === 1
          if (paketVklopljen) {
            vklopljenPaket = idSviTpStr
          }
          if (paketNarocen) {
            narocenPaket = idSviTpStr
            break
          }
        }
        if (narocenPaket !== null) {
          break
        }
      }
      let idTrenutniTp = narocenPaket !== null ? narocenPaket : vklopljenPaket
      // pri spremembi paketov se
      if (idTrenutniTp !== null && idTrenutniTp !== idSviNovPaketString) {
        let besedilo = '<input type="hidden" value="' + this.aneksKey++ + '" />' +
          'Z oddajo naročila spreminjate naročen tržni paket.<br/> <br/>' +
          'Morebitne dodatne storitve, ki so bile del prejšnjega paketa aktivne, ' +
          'bodo ostale še naprej naročene.<br/><br/>' +
          'Spremembe posameznih TV ali mobilnih paketov lahko uredite v meniju "Naroči".'
        MessageBox.alert(besedilo, {
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
          showClose: true,
          showCancelButton: true,
          closeOnPressEscape: true,
          customClass: 'popup-potrditev-spremembe-paketa',
          confirmButtonClass: 'popup-potrditev-spremembe-paketa-button',
          cancelButtonClass: 'popup-cancel-sprememba-trzi-paket-button',
          confirmButtonText: 'STRINJAM SE',
          cancelButtonText: 'Prekliči'
        })
          .then(() => {
            if (idUgodnost === null) {
              this.NarociNovTrzniPaket(paket, idHitrost, idUgodnost)
            } else {
              this.PrikazPogodbe(paket, idHitrost, idUgodnost)
            }
          })
          .catch(() => {
          })
      } else {
        if (idUgodnost === null) {
          this.NarociNovTrzniPaket(paket, idHitrost, idUgodnost)
        } else {
          this.PrikazPogodbe(paket, idHitrost, idUgodnost)
        }
        // this.PrikazPogodbe(paket, idHitrost, idUgodnost)
      }
      setTimeout(function () {
        let gumbPreklici = document.getElementsByClassName('popup-cancel-sprememba-trzi-paket-button')[0]
        if (typeof gumbPreklici !== 'undefined') {
          gumbPreklici.style = 'border: none; font-weight: bold; color: color: var(--almost-black);'
          gumbPreklici.parentElement.append(gumbPreklici)
        }
        let gumbPotrdi = document.getElementsByClassName('popup-potrditev-spremembe-paketa-button')[0]
        if (typeof gumbPotrdi !== 'undefined') {
          gumbPotrdi.style = ''
          gumbPotrdi.disabled = false
        }
      }, 10)
    },
    PrikazPogodbe (paket, idHitrost, idUgodnost) {
      this.podatkiPogodbe = []
      this.podatkiPogodbe['paket'] = paket
      this.podatkiPogodbe['idHitrost'] = idHitrost
      this.podatkiPogodbe['idUgodnost'] = idUgodnost
      this.prikaziDialog = true
    },
    GetSeznamPaketov () {
      for (let i = 0; i < this.seznamNosilnihPrikljuckov.length; i++) {
        if (this.izbranPrikljucek === this.seznamNosilnihPrikljuckov[i].id_prikljucek) {
          this.infoIzbranegaPrikljucka = this.seznamNosilnihPrikljuckov[i]
        }
      }
      this.vklopljenNeaktualniPaket = false
      this.loadingPaketov = true
      this.seznamZavihkov = []
      this.pogrupiranSeznamStoritev = []
      if (this.izbranPrikljucek !== '') {
        let param = []
        param.push('idPrikljucek=' + this.izbranPrikljucek)
        param.push('grupiranjeStoritev=1')
        this.clientAgent.postWsRequest(this,
          'prikljucek/storitve/getNaborTrznihPaketov',
          param,
          this.izbranPrikljucek,
          'SetSeznamPaketov',
          'ErrSeznamPaketov')
      }
    },
    SetSeznamPaketov (podatki, poizvedbaIdPrikljucek) {
      this.pogrupiranSeznamStoritev = []
      if (this.izbranPrikljucek !== poizvedbaIdPrikljucek) {
        return
      }
      this.seznamMoznihStoritev = []
      this.seznamMoznihStoritev = podatki.data
      // 1. sortiranje: po vrstnem redu
      this.seznamMoznihStoritev.sort((a, b) =>
        ('naziv_skupine' in a && (('naziv_skupine' in b && a.vrstni_red >= b.vrstni_red) || !('naziv_skupine' in b)))
          ? 1 : -1)
      // 2. sortiranje: po vrstnem redu skupine
      this.seznamMoznihStoritev.sort((a, b) =>
        ('naziv_skupine' in a &&
          (('naziv_skupine' in b && a.vrstni_red_skupine >= b.vrstni_red_skupine) || !('naziv_skupine' in b)))
          ? 1 : -1)
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        let sviInstanca = this.seznamMoznihStoritev[i]
        Vue.set(sviInstanca, 'naroceno', 0)
        Vue.set(sviInstanca, 'vklopljeno', 0)
        if ('hitrosti' in sviInstanca && sviInstanca.hitrosti !== null) {
          for (let j = 0; j < sviInstanca.hitrosti.length; j++) {
            sviInstanca.hitrosti[j].naroceno = 0
            sviInstanca.hitrosti[j].vklopljeno = 0
            Vue.set(sviInstanca.hitrosti[j], 'cenaSI',
              this.PikeVVejice(parseFloat(sviInstanca.hitrosti[j].cena - sviInstanca.cena).toFixed(2)))
          }
        }
        // storitev prikazi samo ce pripada skupini
        if ('naziv_skupine' in sviInstanca) {
          if (!(sviInstanca.vrstni_red_skupine in this.pogrupiranSeznamStoritev)) {
            this.pogrupiranSeznamStoritev[sviInstanca.vrstni_red_skupine] = []
          }
          sviInstanca.cenaSI = this.PikeVVejice(parseFloat(sviInstanca.cena).toFixed(2))
          this.pogrupiranSeznamStoritev[sviInstanca.vrstni_red_skupine].push(sviInstanca)
        }
      }
      this.updateVklopljeniPaketi()
      this.seznamZavihkov = []
      let zapsSt = 1
      for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
        let storitev = this.seznamMoznihStoritev[i]
        let seNiVSeznamu = true
        for (let j = 0; j < this.seznamZavihkov.length; j++) {
          if (this.seznamZavihkov[j].vrstni_red_skupine === storitev.vrstni_red_skupine) {
            seNiVSeznamu = false
            break
          }
        }
        if (seNiVSeznamu === true) {
          if (typeof storitev.vrstni_red_skupine !== 'undefined' &&
            typeof storitev.naziv_skupine !== 'undefined') {
            let zavihek = {}
            zavihek.vrstni_red_skupine = storitev.vrstni_red_skupine
            zavihek.naziv_skupine = storitev.naziv_skupine
            zavihek.ref = 't' + zapsSt
            zapsSt++
            this.seznamZavihkov.push(zavihek)
          }
        }
        this.activetab = 't1'
      }
      this.seznamMoznihStoritev = this.OlepsajOpiseStoritev(this.seznamMoznihStoritev)
      this.GetUgodnostiPaketov()
    },
    ErrSeznamPaketov (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.loadingPaketov = false
    },
    GetUgodnostiPaketov () {
      if (this.izbranPrikljucek !== '') {
        let stPrikazanihTp = 0
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('modul=horizont.paketi.vezave')
        for (const index in this.pogrupiranSeznamStoritev) {
          for (const index2 in this.pogrupiranSeznamStoritev[index]) {
            param.push('storitve[]=' + this.pogrupiranSeznamStoritev[index][index2].idStoritevVrstaIzbira)
            stPrikazanihTp++
          }
        }
        if (stPrikazanihTp > 0) {
          this.clientAgent.postWsRequest(this,
            'prikljucek/storitve/getUgodnostiStoritev',
            param,
            this.izbranPrikljucek,
            'SetUgodnostiPaketov',
            'ErrUgodnostiPaketov')
        } else {
          this.PridobiNaroceneVklopljenStoritvePrikljucka()
        }
      }
    },
    SetUgodnostiPaketov (podatki, poizvedbaIdPrikljucek) {
      if (this.izbranPrikljucek !== poizvedbaIdPrikljucek) {
        return
      }
      for (const i in podatki.data) {
        let idSviPaketa = podatki.data[i].idStoritevVrstaIzbira
        for (const j in this.pogrupiranSeznamStoritev) {
          for (const k in this.pogrupiranSeznamStoritev[j]) {
            if (this.pogrupiranSeznamStoritev[j][k].idStoritevVrstaIzbira.toString() === idSviPaketa.toString()) {
              this.pogrupiranSeznamStoritev[j][k].ugodnosti = podatki.data[i].ugodnosti
              if (typeof this.pogrupiranSeznamStoritev[j][k].ugodnosti !== 'undefined') {
                for (let l = 0; l < this.pogrupiranSeznamStoritev[j][k].ugodnosti.length; l++) {
                  this.pogrupiranSeznamStoritev[j][k].ugodnosti[l].naroceno = 0
                  this.pogrupiranSeznamStoritev[j][k].ugodnosti[l].vklopljeno = 0
                }
              }
            }
          }
        }
      }
      this.PridobiNaroceneVklopljenStoritvePrikljucka()
    },
    ErrUgodnostiPaketov (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.loadingPaketov = false
    },
    SetVisinaPrikazanihPaketov () {
      let seznamContainerTpPaketKartic = document.getElementsByClassName('postavitev-paketa')
      let seznamTpPaketKartic = document.getElementsByClassName('postavitev-podatkov-paketa')

      let stStolpcev = 1000
      for (let i = 0; i < seznamContainerTpPaketKartic.length; i++) {
        let stil = getComputedStyle(seznamContainerTpPaketKartic[i])
        let seznamStolpci = stil.gridTemplateColumns.split(' ')
        stStolpcev = seznamStolpci.length
      }

      let seznamTpNaslovi = document.getElementsByClassName('postavitev-naziva')
      let seznamiTpOpisi = document.getElementsByClassName('tp-opis')
      let seznamiTpHitrosti = document.getElementsByClassName('tp-hitrost')
      let seznamiTpUgodnosti = document.getElementsByClassName('tp-ugodnost')
      let seznamSpodnjiDeli = document.getElementsByClassName('tp-spodnji-del')

      if (stStolpcev === 1) {
        this.ResetVisineElementov(seznamTpPaketKartic)
        this.ResetVisineElementov(seznamTpNaslovi)
        this.ResetVisineElementov(seznamiTpOpisi)
        this.ResetVisineElementov(seznamiTpHitrosti)
        this.ResetVisineElementov(seznamiTpUgodnosti)
        return
      }

      const NASLOV = 0
      const OPIS = 1
      const HITROST = 2
      const UGODNOST = 3
      const CENA_Z_GUMBOM = 4
      let maxVisineElementovVrstice = []
      let stVrstic = Math.ceil(seznamTpPaketKartic.length / stStolpcev)
      for (let i = 0; i < stVrstic; i++) {
        maxVisineElementovVrstice[i] = []
      }
      this.ResetVisineElementov(seznamTpPaketKartic)
      this.ResetVisineElementov(seznamTpNaslovi)
      this.ResetVisineElementov(seznamiTpOpisi)
      this.ResetVisineElementov(seznamiTpHitrosti)
      this.ResetVisineElementov(seznamiTpUgodnosti)

      let visineNaslovov = this.GetMaxVisineElementovVrstic(seznamTpNaslovi, stStolpcev)
      for (let i = 0; i < visineNaslovov.length; i++) {
        maxVisineElementovVrstice[i][NASLOV] = visineNaslovov[i]
      }
      let visineOpisov = this.GetMaxVisineElementovVrstic(seznamiTpOpisi, stStolpcev)
      for (let i = 0; i < visineOpisov.length; i++) {
        maxVisineElementovVrstice[i][OPIS] = visineOpisov[i]
      }
      let visineHitrosti = this.GetMaxVisineElementovVrstic(seznamiTpHitrosti, stStolpcev)
      for (let i = 0; i < visineHitrosti.length; i++) {
        maxVisineElementovVrstice[i][HITROST] = visineHitrosti[i]
      }
      let visineUgodnosti = this.GetMaxVisineElementovVrstic(seznamiTpUgodnosti, stStolpcev)
      for (let i = 0; i < visineUgodnosti.length; i++) {
        maxVisineElementovVrstice[i][UGODNOST] = visineUgodnosti[i]
      }
      let visineSpodnjegaDela = this.GetMaxVisineElementovVrstic(seznamSpodnjiDeli, stStolpcev)
      for (let i = 0; i < visineSpodnjegaDela.length; i++) {
        maxVisineElementovVrstice[i][CENA_Z_GUMBOM] = visineSpodnjegaDela[i]
      }

      this.SetVisineElementom(seznamTpNaslovi, maxVisineElementovVrstice, stStolpcev, NASLOV)
      this.SetVisineElementom(seznamiTpOpisi, maxVisineElementovVrstice, stStolpcev, OPIS)
      this.SetVisineElementom(seznamiTpHitrosti, maxVisineElementovVrstice, stStolpcev, HITROST)
      this.SetVisineElementom(seznamiTpUgodnosti, maxVisineElementovVrstice, stStolpcev, UGODNOST)
      this.SetVisineElementom(seznamSpodnjiDeli, maxVisineElementovVrstice, stStolpcev, CENA_Z_GUMBOM)
    },
    JeStoritevZaIgnorirat (idStoritev) {
      let storitevIgnorirana = false
      for (let j = 0; j < this.seznamIzvzeteVezave.length; j++) {
        if (parseInt(this.seznamIzvzeteVezave[j]) === idStoritev) {
          storitevIgnorirana = true
          break
        }
      }
      return storitevIgnorirana
    },
    GetMaxVisineElementovVrstic (seznamElementi, stStolpcev) {
      let seznamVisin = []
      let obravnavanaVrstica = -1
      for (let i = 0; i < seznamElementi.length; i++) {
        if (i % stStolpcev === 0) {
          obravnavanaVrstica++
        }
        seznamVisin[obravnavanaVrstica] = 0
      }
      obravnavanaVrstica = -1
      for (let i = 0; i < seznamElementi.length; i++) {
        if (i % stStolpcev === 0) {
          obravnavanaVrstica++
        }
        let offsetHeight = seznamElementi[i].scrollHeight
        if (offsetHeight > seznamVisin[obravnavanaVrstica]) {
          seznamVisin[obravnavanaVrstica] = offsetHeight
        }
      }
      return seznamVisin
    },
    ResetVisineElementov (seznam) {
      for (let i = 0; i < seznam.length; i++) {
        seznam[i].style.height = 'auto'
      }
    },
    SetVisineElementom (seznamElementov, maxVisineElementovVrstice, stStolpcev, komponenta) {
      let obravnavanaVrstica = -1
      for (let i = 0; i < seznamElementov.length; i++) {
        if (i % stStolpcev === 0) {
          obravnavanaVrstica++
        }
        let visina = maxVisineElementovVrstice[obravnavanaVrstica][komponenta] // + maxVisineCenaZGumbom[obravnavanaVrstica]
        seznamElementov[i].style.height = visina + 'px'
      }
    },
    SetSeznamNarocenihStoritev (prenosniParametri, seznamNarocenih) {
      if (this.izbranPrikljucek !== prenosniParametri.prenesenIzbranId) {
        return
      }
      let naroceneStoritve = seznamNarocenih
      this.naroceneStoritve = seznamNarocenih
      if (naroceneStoritve.length > 0) {
        for (let i = 0; i < this.pogrupiranSeznamStoritev.length; i++) {
          if (typeof this.pogrupiranSeznamStoritev[i] === 'undefined') {
            continue
          }
          for (let j = 0; j < this.pogrupiranSeznamStoritev[i].length; j++) {
            let idSviTp = this.pogrupiranSeznamStoritev[i][j].idStoritevVrstaIzbira
            let tpNajden = false
            for (let k = 0; k < naroceneStoritve.length; k++) {
              if (naroceneStoritve[k].idStoritev === idSviTp) {
                this.pogrupiranSeznamStoritev[i][j].naroceno = 1
                tpNajden = true
                break
              }
            }
            if (tpNajden === true) {
              let naborHitrosti = this.pogrupiranSeznamStoritev[i][j].hitrosti
              for (let l = 0; l < naborHitrosti.length; l++) {
                for (let k = 0; k < naroceneStoritve.length; k++) {
                  if (naroceneStoritve[k].idStoritev === naborHitrosti[l].idStoritevVrstaIzbira) {
                    this.pogrupiranSeznamStoritev[i][j].hitrosti[l].naroceno = 1
                    break
                  }
                }
              }
              if (this.pogrupiranSeznamStoritev[i][j].ugodnosti !== undefined) {
                let naborUgodnosti = this.pogrupiranSeznamStoritev[i][j].ugodnosti
                for (let l = 0; l < naborUgodnosti.length; l++) {
                  for (let k = 0; k < naroceneStoritve.length; k++) {
                    if (naroceneStoritve[k].idStoritev === naborUgodnosti[l].idStoritevVrstaIzbira) {
                      this.pogrupiranSeznamStoritev[i][j].ugodnosti[l].naroceno = 1
                      break
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.infoPripisObPaketu = false
      if (this.vklopljenNeaktualniPaket && this.activetab === 't1') {
        this.infoPripisObPaketu = true
      }
      this.loadingPaketov = false
      this.izbranaUgodnostPaket = {}
      this.seznamIzbranaUgodnostPaket = []
      this.SetPrivzeteIzbire()
      this.tabKey++
      this.updateVklopljeniPaketi()
    },
    SetSeznamVkloplenihStoritev (prenosniParametri, seznamVklopljenih) {
      if (this.izbranPrikljucek !== prenosniParametri.prenesenIzbranId) {
        return
      }
      this.vklopljeneStoritve = seznamVklopljenih
      let vklopljenTp = null

      if (this.vklopljeneStoritve.length > 0) {
        for (let i = 0; i < this.seznamMoznihStoritev.length; i++) {
          for (let j = 0; j < this.vklopljeneStoritve.length; j++) {
            if (this.vklopljeneStoritve[j].idStoritev === this.seznamMoznihStoritev[i].idStoritevVrstaIzbira) {
              Vue.set(this.seznamMoznihStoritev[i], 'vklopljeno', 1)
              vklopljenTp = this.seznamMoznihStoritev[i]
            }
          }
        }
      }
      this.vklopljenNeaktualniPaket = false
      // v primeru, da vklopljen trzni paket ni vec v aktualni ponudbi
      if (vklopljenTp !== null && typeof vklopljenTp.vrstni_red_skupine === 'undefined') {
        this.vklopljenNeaktualniPaket = true
        Vue.set(vklopljenTp, 'neaktualna_ponudba', 1)
        let zavihek = {}
        zavihek.vrstni_red_skupine = 1
        Vue.set(zavihek, 'neaktualna_ponudba', true)
        zavihek.naziv_skupine = 'Vaš paket'
        zavihek.ref = 't1'
        this.seznamZavihkov.unshift(zavihek)
        for (let i = 0; i < this.seznamZavihkov.length; i++) {
          this.seznamZavihkov[i].ref = 't' + (i + 1)
          this.seznamZavihkov[i].vrstni_red_skupine = (i + 1)
        }
        let tempSeznam = JSON.parse(JSON.stringify(this.pogrupiranSeznamStoritev))
        let dolzinaSeznama = tempSeznam.length
        for (let i = 0; i < dolzinaSeznama; i++) {
          this.pogrupiranSeznamStoritev[i + 2] = tempSeznam[i + 1]
        }
        this.pogrupiranSeznamStoritev[1] = []
        this.pogrupiranSeznamStoritev[1].push(vklopljenTp)
      }
      if (this.vklopljeneStoritve.length > 0) {
        for (let i = 0; i < this.pogrupiranSeznamStoritev.length; i++) {
          if (typeof this.pogrupiranSeznamStoritev[i] === 'undefined') {
            continue
          }
          for (let j = 0; j < this.pogrupiranSeznamStoritev[i].length; j++) {
            let idSviTp = this.pogrupiranSeznamStoritev[i][j].idStoritevVrstaIzbira
            let tpNajden = false
            for (let k = 0; k < this.vklopljeneStoritve.length; k++) {
              if (this.vklopljeneStoritve[k].idStoritev === idSviTp) {
                this.pogrupiranSeznamStoritev[i][j].vklopljeno = 1
                tpNajden = true
                break
              }
            }
            if (tpNajden === true) {
              let naborHitrosti = this.pogrupiranSeznamStoritev[i][j].hitrosti
              if (typeof naborHitrosti !== 'undefined' && naborHitrosti !== null) {
                for (let l = 0; l < naborHitrosti.length; l++) {
                  for (let k = 0; k < this.vklopljeneStoritve.length; k++) {
                    if (this.vklopljeneStoritve[k].idStoritev === naborHitrosti[l].idStoritevVrstaIzbira) {
                      this.pogrupiranSeznamStoritev[i][j].hitrosti[l].vklopljeno = 1
                      break
                    }
                  }
                }
              }
              let naborUgodnosti = this.pogrupiranSeznamStoritev[i][j].ugodnosti
              if (typeof naborUgodnosti !== 'undefined' && naborUgodnosti !== null) {
                for (let l = 0; l < naborUgodnosti.length; l++) {
                  for (let k = 0; k < this.vklopljeneStoritve.length; k++) {
                    if (this.vklopljeneStoritve[k].idStoritev === naborUgodnosti[l].idStoritevVrstaIzbira) {
                      this.pogrupiranSeznamStoritev[i][j].ugodnosti[l].vklopljeno = 1
                      break
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.infoPripisObPaketu = false
      if (this.vklopljenNeaktualniPaket && this.activetab === 't1') {
        this.infoPripisObPaketu = true
      }
      this.GetNaroceneStoritve(prenosniParametri)
      this.updateVklopljeniPaketi()
    },
    SetPrivzeteIzbire () {
      let idIzbranPaket = null
      let idIzbranaHitrost = null
      let idIzbranaUgodnost = null
      this.izbranaHitrostPaket = {}
      this.izbranaUgodnostPaket = {}

      // prioritetno preverjanje naroceno
      for (let i = 0; i < this.pogrupiranSeznamStoritev.length; i++) {
        if (typeof this.pogrupiranSeznamStoritev[i] === 'undefined') {
          continue
        }
        for (let j = 0; j < this.pogrupiranSeznamStoritev[i].length; j++) {
          let posamezenPaket = this.pogrupiranSeznamStoritev[i][j]
          let idSviPaketa = posamezenPaket.idStoritevVrstaIzbira
          if (idSviPaketa !== null) {
            this.izbranaHitrostPaket[idSviPaketa] = null
          }
          // preverjanje naroceno: tp
          if (posamezenPaket.naroceno === 1) {
            idIzbranPaket = idSviPaketa
          }
          // preverjanje naroceno: hitrost
          if (typeof posamezenPaket.hitrosti !== 'undefined' && posamezenPaket.hitrosti !== null) {
            for (let k = 0; k < posamezenPaket.hitrosti.length; k++) {
              if (posamezenPaket.hitrosti[k].naroceno === 1) {
                idIzbranaHitrost = posamezenPaket.hitrosti[k].idStoritevVrstaIzbira
              }
            }
          }
          // preverjanje naroceno: ugodnosti
          if (typeof posamezenPaket.ugodnosti !== 'undefined' && posamezenPaket.ugodnosti !== null) {
            for (let k = 0; k < posamezenPaket.ugodnosti.length; k++) {
              let idSviUgodnosti = posamezenPaket.ugodnosti[k].idStoritevVrstaIzbira
              Vue.set(this.izbranaUgodnostPaket, idSviUgodnosti + '_' + idSviPaketa, false)
              if (posamezenPaket.ugodnosti[k].naroceno === 1) {
                idIzbranaUgodnost = idSviUgodnosti
              }
            }
          }
        }
      }

      // vklopljene storitve izbrane samo ce ni narocenih
      for (let i = 0; i < this.pogrupiranSeznamStoritev.length; i++) {
        if (typeof this.pogrupiranSeznamStoritev[i] === 'undefined') {
          continue
        }
        for (let j = 0; j < this.pogrupiranSeznamStoritev[i].length; j++) {
          let posamezenPaket = this.pogrupiranSeznamStoritev[i][j]
          let idSviPaketa = posamezenPaket.idStoritevVrstaIzbira
          // preverjanje vklopljeno: tp
          if (idIzbranPaket === null && posamezenPaket.vklopljeno === 1) {
            idIzbranPaket = idSviPaketa
          }
          // preverjanje vklopljeno: hitrost
          if (typeof posamezenPaket.hitrosti !== 'undefined' && posamezenPaket.hitrosti !== null) {
            for (let k = 0; k < posamezenPaket.hitrosti.length; k++) {
              if (idIzbranaHitrost === null && posamezenPaket.hitrosti[k].vklopljeno === 1) {
                idIzbranaHitrost = posamezenPaket.hitrosti[k].idStoritevVrstaIzbira
              }
            }
          }
          // preverjanje vklopljeno: ugodnosti
          if (typeof posamezenPaket.ugodnosti !== 'undefined' && posamezenPaket.ugodnosti !== null) {
            for (let k = 0; k < posamezenPaket.ugodnosti.length; k++) {
              let idSviUgodnosti = posamezenPaket.ugodnosti[k].idStoritevVrstaIzbira
              this.seznamIzbranaUgodnostPaket[idSviUgodnosti + '_' + idSviPaketa] = false
              if (idIzbranaUgodnost === null && posamezenPaket.ugodnosti[k].vklopljeno === 1) {
                idIzbranaUgodnost = idSviUgodnosti
              }
            }
          }
        }
      }
      if (idIzbranPaket !== null) {
        this.izbranaHitrostPaket[idIzbranPaket] = idIzbranaHitrost + '_' + idIzbranPaket
      }
      if (idIzbranaUgodnost !== null) {
        this.izbranaUgodnostPaket[idIzbranaUgodnost + '_' + idIzbranPaket] = true
      }
    },
    NarociNovTrzniPaket (paket, idHitrost, idUgodnost) {
      if (this.izbranPrikljucek !== '') {
        let param = []
        param.push('idPrikljucek=' + this.izbranPrikljucek)
        param.push('idTrzniPaket=' + paket.idStoritevVrstaIzbira)
        param.push('idStoritveHitrosti=' + idHitrost)
        if (idUgodnost !== null) {
          param.push('idStoritevVezave[]=' + idUgodnost)
        }
        this.clientAgent.postWsRequest(this,
          'prikljucek/storitve/narociTrzniPaket',
          param,
          paket.idStoritevVrstaIzbira,
          'SetNarociNovTrzniPaket',
          '')
      }
    },
    SetNarociNovTrzniPaket () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno naročen nov paket.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetSeznamPaketov()
    }
  }
}
</script>
<style>
.popup-potrditev-trzi-paket, .popup-potrditev-spremembe-paketa{
  min-width: 530px;
  min-height: 350px;
  padding: 0 42px 0 41px;
  text-align: center;
}

.popup-potrditev-trzi-paket .el-message-box__title,
.popup-potrditev-trzi-paket .el-message-box__content,
.popup-potrditev-spremembe-paketa .el-message-box__content,
.popup-potrditev-spremembe-paketa .el-message-box__title{
  text-align: center;
  margin-bottom: 45px;
}

.popup-potrditev-trzi-paket .el-message-box__btns , .popup-potrditev-spremembe-paketa .el-message-box__btns {
  display: flex;
  justify-content: center;
  flex-flow: column!important;
  flex-shrink: revert;
  margin: 0 10% 20px 10% !important;
  padding-top: 0 !important;
}

.popup-potrditev-trzi-paket .el-message-box__content, .popup-potrditev-spremembe-paketa .el-message-box__content {
  padding: 0;
}

.popup-potrditev-trzi-paket-button, .popup-potrditev-spremembe-paketa-button {
  background-color: #EF7D00 !important;
  border-color: #EF7D00 !important;
  font-size: 13px;
  font-weight: 800 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  padding: 11px 20px !important;
  letter-spacing: 0.26px;
  border-radius: 4px !important;
  color: #ffffff !important;
  white-space: initial;
}

.popup-potrditev-trzi-paket label {
  margin-bottom: 0px;
}

.el-message-box.popup-potrditev-trzi-paket, .el-message-box.popup-potrditev-spremembe-paketa {
  padding: 0 42px 0 41px;
}

.popup-potrditev-trzi-paket .el-message-box__headerbtn, .popup-potrditev-spremembe-paketa .el-message-box__headerbtn  {
  display: none;
  margin: 0 auto;
}

.popup-potrditev-trzi-paket .popup-cancel-trzi-paket-button,
.popup-potrditev-spremembe-paketa .popup-cancel-sprememba-trzi-paket-button {
  background-color: transparent !important;
  color: #080809 !important;
  font-weight: 800;
  border: 0;
  font-size: 13px;
  line-height: 41px;
  padding-top: 0;
  padding-bottom: 0;
}

.el-message-box__btns button:nth-child(2) {
  margin-left: 0;
}

.popup-potrditev-trzi-paket .popup-cancel-trzi-paket-button:hover,
.popup-potrditev-spremembe-paketa .popup-cancel-sprememba-trzi-paket-button:hover {
  background-color: transparent;
}

.popup-potrditev-trzi-paket .el-message-box__title:before,
.popup-potrditev-spremembe-paketa .el-message-box__title:before {
  background-image: url("/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png");
  background-size: 100px 100px;
  background-repeat: no-repeat;
  margin: 18px auto 34px auto;
  height: 100px;
  width: 100px;
  display: block;
  content: "";
}

.postavitev-naslova-pogodba-paketi {
  font-weight: 600;
}

input[type=checkbox] {
  margin-right: 5px;
  vertical-align: text-top;
}

@media only screen and (max-width: 600px) {
  .popup-potrditev-trzi-paket, .popup-potrditev-spremembe-paketa {
    min-width: 0;
    width: 89% !important;
  }
}

</style>
<style scoped src="../../../../../static/css/Naroci/NarociPaketi/NarociPaketi.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociT2Paket.vue